interface Config {
	threshold?: number;
	duration?: number;
	delay?: number;
	distance?: string;
	easing?: string;
}

export function slideIn(node: HTMLElement, config: Config = {}) {
	const {
		threshold = 0.3,
		delay = 0,
		duration = 600,
		distance = '100px',
		easing = 'ease-out'
	} = config;

	// hide the element initially
	node.style.opacity = '0.01';
	node.style.transform = `translate3d(0,${distance},0)`;

	const observer = new IntersectionObserver(
		(entries, o) => {
			if (!entries[0].isIntersecting) return;

			o.disconnect();

			const animation = node.animate(
				[
					{ transform: `translate3d(0,${distance},0)`, opacity: 0.01 },
					{ transform: 'translate3d(0,0,0)', opacity: 1 }
				],
				{
					duration,
					delay,
					easing,
					fill: 'forwards'
				}
			);

			// make sure to always have the final state,
			// even when the animation is interrupted
			animation.onfinish = () => {
				node.style.opacity = '1';
				node.style.transform = 'translate3d(0,0,0)';
			};
		},
		{ threshold }
	);
	observer.observe(node);

	return {
		destroy() {
			observer?.disconnect();
		}
	};
}
